/* eslint-disable */
import { addListener, makeEvent } from "~/lib/signals";
import { node } from "~/util/dom";
import { Item } from "./item";
import EditAddress from "./edit";
import Scene from "~/scene";

export interface IItemData {
	create_time?: number,
	dataType?: string,
	deleted?: boolean,
	id?: string,
	mark?: {
		lat: number,
		lon: number
	},
	public?: boolean,
	source?: string,
	source_id?: number,
	state?: number,
	title: string,
	type: string,
	update_time?: number,
}

export interface IItems {
	home?: IItemData,
	work?: IItemData,
}

/**
 * Trida pro praci s domov a prace
 */
export default class HomeAndWork2 {
	#layer: any;
	#dom: {
		container: HTMLDivElement;
		homeAndWorkItems: HTMLDivElement;
	};
	#editAddress: any;
	#data: IItems;
	#items: {
		home: Item;
		work: Item;
	};
	#activeDetail: boolean;
	#detailMarker: any;

	constructor(layer) {
		this.#layer = layer;
		this.#dom = {
			container: node("div", { className: "home-and-work2" }),
			homeAndWorkItems: node("div", { className: "items" }),
		};
		this.#editAddress = new EditAddress({
			saveCb: (type, data) => {
				this.#data[type] = data
				this.#items[type].data = data;
				this.#addMarkers([this.#items[type]]);
				this.#editAddress.close();
				this.#setClearItems();
				Mapy.getComponent("places").updateLikeList();
			},
			resetCb: (type) => {
				this.#removeMarkers([this.#items[type]]);
				this.#data[type] = null;
				this.#items[type].data = null;
				this.#editAddress.close();
				this.#setClearItems();
				Mapy.getComponent("places").updateLikeList();
			},
			closeCb: (type) => {
				this.#items[type].container.classList.remove("edit");
			}
		});
		this.#dom.container.append(this.#dom.homeAndWorkItems, this.#editAddress.container);
		this.#data = null;
		this.#items = {
			home: null,
			work: null,
		};
		this.#activeDetail = false;
		this.#detailMarker = null;

		addListener(this, "places-marker-rewrite", () => {
			this.#addMarkers();
		});

		addListener(this, "detail-deactivated", () => {
			this.#activeDetail = false;

			if (this.#detailMarker) {
				this.#layer.addMarker(this.#detailMarker);
				this.#detailMarker = null;
			}

			this.#setMarkersActive(undefined, true);
		});

		addListener(this, "detail-activated", () => {
			this.#activeDetail = true;

			this.#setMarkersActive(undefined);
		});
	}

	destroy() {}

	/**
	 * Obal.
	 *
	 * @return {Element}
	 */
	get container() {
		return this.#dom.container;
	}

	/**
	 * zobrazit
	 */
	show() {
		this.#dom.container.classList.remove("hide");
	}

	/**
	 * skryt
	 */
	hide() {
		this.#dom.container.classList.add("hide");
	}

	/**
	 * vycistit
	 */
	clear() {
		this.#removeMarkers();

		this.#dom.homeAndWorkItems.innerHTML = "";

		if (this.#activeDetail) {
			let state = Mapy.getComponent("detail").getState();
			Mapy.getComponent("detail").setState({ ...state, show: false });
		}
	}

	/**
	 * Nacteni - vytvoreni a bindovani itemu.
	 */
	load() {
		Mapy.ProviderMapyBox.getHomeAndWork().then(data => {
			this.#data = data;

			this.clear();

			const callbacks = {
				editCb: (type) => {
					this.#editAddress.open(this.#editData(type));

					for (let t in this.#items) {
						this.#items[t].container.classList[t === type ? "add" : "remove"]("edit");
					}

					this.#closeItemMenu();
				},
				deleteCb: (type) => {
					this.#editAddress.delete(this.#editData(type));
				},
				gotoCb: (type) => { this.#openDetail(type) },
				menuCb: (type, open) => {
					if (open) {
						this.#closeItemMenu(type);
					}
				},
				highlightCb: (type, state) => { this.#highlightItem(type, state) },
			};

			const types = Object.keys(this.#items);

			types.forEach(type => {
				if (!this.#items[type]) { // pokud nemamem, vytvorime
					this.#items[type] = new Item(type, this.#data, callbacks);
					if (this.#activeDetail) {
						this.#items[type].marker.setActive();
						this.#items[type].marker.setFocus();
					}
				}
				else if (this.#items[type].isChange(this.#data[type])) { // pokud doslo k nejake zmene, prebuildime
					this.#items[type].data = this.#data[type];
				}

				this.#dom.homeAndWorkItems.append(this.#items[type].container);
			});

			this.#addMarkers();

			this.#setClearItems();
		}, () => {});
	}

	closeEdit() {
		this.#editAddress.close();
	}

	setEmptyItems() {
		this.#data = null;

		for(const type in this.#items) {
			this.#items[type].data = null;
		}

		this.#removeMarkers();
		this.#setClearItems();
	}

	/**
	 * Pridaniu markeru
	 *
	 * @param items itemy, ze kterych se markery maji pridat
	 */
	#addMarkers(items = [this.#items.home, this.#items.work]) {
		items.forEach(item => {
			if (item?.marker && !item.marker.appended) {
				this.#layer.addMarker(item.marker);
			}
		});
	}

	/**
	 * Odebrani markeru
	 *
	 * @param items itemy, ze kterych se markery maji odebrat
	 */
	 #removeMarkers(items = [this.#items.home, this.#items.work]) {
		items.forEach(item => {
			if (item?.marker && item.marker.appended) {
				this.#layer.removeMarker(item.marker);
			}
		});
	}

	/**
	 * nasatveni stavu markeru
	 *
	 * @param items itemy, ktere se maji nastavit
	 * @param active aktivni?
	 */
	#setMarkersActive(items = [this.#items.home, this.#items.work], active = false) {
		items.forEach(item => {
			if (item?.marker) {
				item.marker.setActive(active);
				item.marker.setFocus(active);
			}
		});
	}

	/**
	 * Otevreni detailu daneho typu.
	 *
	 * @param  type Typ - home/work
	 */
	#openDetail(type: string) {
		let data = this.#data[type];

		if (!data || !data.mark || this.#editAddress.isOpen) return;

		let coords = Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
		let state: {
			show: boolean,
			source?: string,
			id?: string|Number,
			coords: any,
			gpsCoords: any,
			markerIcon: string;
		} = {
			show: true,
			coords: coords,
			gpsCoords: coords,
			markerIcon: type,
		};

		switch (data.dataType) {
			case "point":
				state.source = "coor";
				state.id = data.mark.lon + "," + data.mark.lat;
				break;

			case "entity":
				state.source = data.source;
				state.id = data.source_id;
				break;
		}

		//nebyl marker, který je v detailu, smazán? Pokud ano, tak ho vrátím do mapy
		if (this.#detailMarker) {
			let detailId = this.#detailMarker.itemId;
			let markerInLayer = this.#layer.getMarkers().reduce((accum, item) => {
				return accum || item.itemId == detailId;
			}, false);
			if (!markerInLayer) {
				Object.keys(this.#items).forEach(key => {
					if (this.#items[key].marker.itemId == detailId) {
						this.#layer.addMarker(this.#items[key].marker);
					}
				});
			}
		}

		Mapy.getComponent("detail").setState(state).then(() => {
			this.#layer.removeMarker(this.#items[type].marker);
			this.#detailMarker = this.#items[type].marker;
			Mapy.getComponent("history").save();
		}, () => {});
	}

	#closeItemMenu(type?: string) {
		for (let item in this.#items) {
			item !== type && this.#items[item].closeMenu();
		}
	}

	/**
	 * Zvyrazneni pres marker na item.
	 *
	 * @param  type Typ - home/work
	 * @param  state True je aktiv
	 */
	#highlightItem(type: string, state: boolean = false) {
		this.#items[type].container.classList[state ? "add" : "remove"]("active");
		if (this.#items[type].marker) {
			makeEvent("homeAndWork-highlight", this, state ? { marker: this.#items[type].marker } : null);

			state && this.#setMarkersActive([this.#items[type].marker], state);
		}
	}

	/**
	 * Je prace a domov prazdne?
	 */
	#setClearItems() {
		let workID = this.#data && this.#data.work ? this.#data.work.id : null;
		let homeID = this.#data && this.#data.home ? this.#data.home.id : null;

		this.#dom.homeAndWorkItems.classList[!workID && !homeID ? "add" : "remove"]("clear-items");
	}

	/**
	 * Vraci potrebna data pro editaci danneho itemu
	 *
	 * @param type typ itemu
	 * @returns
	 */
	#editData(type: string): {
		type: string,
		title: string,
		id?: string,
	} {
		return {
			type,
			title: this.#data[type] && this.#data[type].title ? this.#data[type].title : "",
			...this.#data[type] && this.#data[type].id ? { id: this.#data[type].id } : {},
		};
	}
}
